export default Object.freeze({
    "LEFT": "LEFT",
    "RIGHT": "RIGHT"
});